import { useState } from "react";
import { faqs } from "@/mocks/communityData";
import SectionTitle from "./SectionTitle";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <SectionTitle eyebrow="常见问题" title="关于吃瓜聚集地，你可能想知道" />
        <div className="space-y-3">
          {faqs.map((item, idx) => {
            const isOpen = openIdx === idx;
            return (
              <div key={idx} className="overflow-hidden rounded-2xl border border-background-200 bg-background-50">
                <button
                  type="button"
                  onClick={() => setOpenIdx(isOpen ? null : idx)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">{item.q}</h3>
                  <i
                    className={`shrink-0 text-xl text-primary-500 transition-transform duration-300 ${isOpen ? "rotate-180" : ""} ${
                      isOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"
                    }`}
                    aria-hidden="true"
                  ></i>
                </button>
                {isOpen && (
                  <p className="border-t border-background-100 px-5 pb-5 pt-4 text-sm leading-relaxed text-foreground-600">
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}